angular.module('qkr').controller('couponPreviewController', ($scope, $uibModalInstance, $timeout, gettextCatalog,
                                                             coupon, merchantInfo) => {

    $scope.merchantName = merchantInfo.name;
    $scope.coupon = coupon;

    const init = function() {
        // Hack to get rid of scrollbar that appears on the outside of modals sometimes
        $timeout(() => {
            const modalContainer = angular.element('.modal');
            modalContainer.css('overflow-y', 'hidden');
        }, 1000);
    };

    if ((coupon.name && coupon.name.length === 0) || !coupon.name) {
        $scope.coupon.name = gettextCatalog.getString('Coupon Name');
    }

    if ((coupon.description && coupon.description.length === 0) || !coupon.description) {
        $scope.coupon.description = gettextCatalog.getString('Coupon Description');
    }

    if ((coupon.imageUrl && coupon.imageUrl.length === 0) || !coupon.imageUrl) {
        $scope.coupon.imageUrl = merchantInfo.coverImage;
    }

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    init();
});



// WEBPACK FOOTER //
// ./src/coupons/controllers/coupon.preview.controller.js